const parsePixelValue = (styleStr) => parseInt(styleStr.replace("px", ""));
export {
  parsePixelValue
};
//# sourceMappingURL=parsePixelValue.js.map
